<template>
  <div v-if="!loading">
    <v-card elevation="20" style="height: 100vh">
      <v-toolbar class="text-white rounded-0" color="primary" height="65px">
        <a @click.prevent="$router.go(-1)">
          <v-btn class="mb-2" dark icon small>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
        <v-toolbar-title class="ml-3">
          <h3>{{ title }}</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <router-link
          :to="{ name: 'user-edit', params: { id: getCurrentLead?.user_id } }"
        >
          <v-btn
            v-if="getCurrentLead.user_id && !isAgent"
            color="primary"
            elevation="0"
          >
            Kullanıcıya Git
          </v-btn>
        </router-link>
        <v-spacer></v-spacer>
        <div>
          <v-menu v-model="menu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="search"
                append-icon="search"
                dark
                hide-details="auto"
                label="Lead Ara"
                single-line
                style="width: 300px"
                v-bind="attrs"
                @input="searchLead"
                v-on="on"
              ></v-text-field>
            </template>

            <v-card>
              <v-list dense>
                <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(lead, index) in filteredLeads"
                    :key="index"
                  >
                    <router-link
                      :to="{ name: 'lead-show', params: { id: lead?.id } }"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ lead.name }}</v-list-item-title>
                      </v-list-item-content>
                    </router-link>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </v-toolbar>
      <v-system-bar class="pa-4 text-white" color="indigo" dark>
        <v-row align="center" justify="space-between">
          <v-col cols="3">
            <div v-if="getCurrentLead?.agent_id">
              <span class="text-lg-h6 text-md-body-1"
                ><b>Agent - </b>{{ getCurrentLead?.agent?.name }}</span
              >
              <v-dialog v-model="agentDialog" max-width="400px" scrollable>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-1 mb-1" small v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <v-card>
                  <v-card-title class="mx-auto">Agent Atama</v-card-title>
                  <v-card-text style="height: 200px">
                    <v-list max-height="200px" rounded>
                      <v-list-item
                        v-for="log in agentLogs"
                        :key="log?.id"
                        class="bg-light-danger mb-2"
                        link
                        three-line
                      >
                        <template v-slot:default>
                          <v-list-item-content>
                            <v-list-item-title>
                              <strong>Lead Manager - </strong
                              >{{ log.causer.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span class="text-primary">{{
                                returnLocaleDate(log.created_at)
                              }}</span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                              v-if="log.properties.newValue"
                            >
                              {{
                                log.properties.oldValue
                              }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              v-if="!log.properties.newValue"
                            >
                              <b> {{ log.properties.oldValue }} </b> agent
                              olarak atandı.
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-content-end">
                    <v-btn color="error" @click="agentDialog = false">
                      Kapat
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
          <v-col class="d-flex justify-content-center" cols="4">
            <v-dialog v-model="flowDialog" :max-width="1200">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-1 mb-1" small v-bind="attrs" v-on="on"
                  >mdi-help-circle-outline</v-icon
                >
              </template>
              <Card modal title="Lead Flow Diagram">
                <template #close>
                  <v-btn icon @click="flowDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <img
                  height="100%"
                  src="@/assets/images/lead_flow.png"
                  width="100%"
                />
              </Card>
            </v-dialog>
            <span class="text-lg-h6 text-md-body-1"
              ><b>Lead Durumu - </b
              >{{ getLeadStatusTranslate(getCurrentLead.status) }}</span
            >
            <v-dialog v-model="leadDialog" max-width="400px" scrollable>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-1 mb-1" small v-bind="attrs" v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <v-card>
                <v-card-title class="mx-auto">Lead Durum Akışı</v-card-title>
                <v-card-text style="height: 200px">
                  <v-list max-height="200px" rounded>
                    <v-list-item
                      v-for="log in leadFlow"
                      :key="log?.id"
                      class="bg-light-danger mb-2"
                      link
                      three-line
                    >
                      <template v-slot:default>
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong
                              >{{
                                log?.causer?.roles[0]?.description
                              }}
                              - </strong
                            >{{ log?.causer?.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <span class="text-primary">{{
                              returnLocaleDate(log?.created_at)
                            }}</span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            <b>Durum: </b> {{ log.properties.newValue }}
                            <v-icon color="error" small>mdi-arrow-right</v-icon>
                            {{ log.properties.oldValue }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-actions class="d-flex justify-content-end">
                  <v-btn color="error" @click="leadDialog = false">
                    Kapat
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <SendRegisterForm
              v-if="getCurrentLead?.status === 3"
              :lead_id="getCurrentLead?.id"
            />
            <SendVerifyEmailAgain
              v-if="getCurrentLead?.status === 4"
              :lead_id="getCurrentLead?.id"
            />
          </v-col>
          <v-col class="d-flex justify-content-end" cols="4">
            <SMAgentActionButtons :lead="getCurrentLead"></SMAgentActionButtons
          ></v-col>
        </v-row>
      </v-system-bar>
      <v-card-text class="pa-4">
        <v-row class="text-body-1" justify="space-between">
          <v-col class="d-flex flex-column" cols="3">
            <span><b>Kanal: </b>{{ getCurrentLead?.channel?.name }}</span>
            <span><b>Kampanya: </b>{{ getCurrentLead?.campaign?.name }}</span>
            <span>
              <b>İndirim Kodu: </b>
              {{ getCurrentLead?.discount_code }}
            </span>
          </v-col>
          <v-col class="d-flex flex-column" cols="3">
            <span>
              <b>E-Posta: </b>
              <a :href="'mailto:' + getCurrentLead?.email"
                >{{ getCurrentLead?.email }}
              </a>
            </span>
            <span>
              <b>Telefon: </b>
              <a :href="'tel:' + getCurrentLead?.phone"
                >{{ formatPhoneInput(getCurrentLead?.phone) }}
              </a>
            </span>
            <span>
              <b>İkinci Telefon: </b>
              <a :href="'tel:' + getCurrentLead?.secondary_phone"
                >{{ formatPhoneInput(getCurrentLead?.secondary_phone) }}
              </a>
            </span>
            <div v-if="getCurrentLead?.lead_result">
              <span
                ><b>Sonuç Kodu:</b>
                {{
                  getLeadResultCodeTranslate(
                    getCurrentLead.lead_result?.result_code_id
                  )
                }}</span
              >
            </div>
          </v-col>
          <v-col class="d-flex flex-column" cols="3">
            <span>
              <b>Meslek: </b>
              {{
                getCurrentLead?.job_title
                  ? getCurrentLead?.job_title
                  : "Belirtilmedi"
              }}
            </span>
            <span>
              <b>Neden Yazılımcı Olmak İstiyor: </b>
              {{
                getCurrentLead?.application_reason
                  ? getLeadApplicationReason(getCurrentLead?.application_reason)
                  : "Belirtilmedi"
              }}
            </span>
            <div v-if="getCurrentLead.lead_result">
              <span
                ><b>Alt Sonuç Kodu:</b>
                {{
                  getLeadResultCodeTranslate(
                    getCurrentLead.lead_result?.sub_result_code_id
                  )
                }}</span
              >
            </div>
          </v-col>
          <v-col class="d-flex flex-column" cols="3">
            <span
              ><b>Başvuru Tarihi: </b>
              {{ getCurrentLead?.application_date }}</span
            >
            <span
              ><b>İndirimli Ürün İnceleme: </b>
              {{
                getCurrentLead?.discounted_package_view
                  ? "İncelendi"
                  : "İncelenmedi"
              }}</span
            >
          </v-col>
        </v-row>
        <div v-if="getCurrentLead.google_lead">
          <v-row class="text-body-1" justify="space-between">
            <v-col class="d-flex flex-column" cols="2">
              <span><b>UTM Source: </b></span>
              <span>{{ getCurrentLead?.google_lead?.utm_source }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>UTM Medium: </b></span>
              <span>{{ getCurrentLead?.google_lead?.utm_medium }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>UTM Campaign: </b></span>
              <span>{{ getCurrentLead?.google_lead?.utm_campaign }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>UTM Term: </b></span>
              <span>{{ getCurrentLead?.google_lead?.utm_term }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>UTM Content: </b></span>
              <span>{{ getCurrentLead?.google_lead?.utm_content }}</span>
            </v-col>
          </v-row>
        </div>
        <div v-if="getCurrentLead.lead_from_funnel">
          <v-row
            class="text-body mt-3 bg-dark text-white p-1 px-3 font-size-lg"
          >
            <div>Lead Funnel Bilgileri</div>
          </v-row>
          <v-row class="text-body-1" justify="space-between">
            <v-col class="d-flex flex-column" cols="2">
              <span><b>Tecrübe: </b></span>
              <span>{{ getCurrentLead?.lead_from_funnel?.experience }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>Tecrübe Alanı: </b></span>
              <span>{{
                getCurrentLead?.lead_from_funnel?.experienced_area
              }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>Tercih ettiği haftalık ders süresi: </b></span>
              <span>{{
                getCurrentLead?.lead_from_funnel?.preferred_weekly_hours
              }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>Bütçe: </b></span>
              <span>{{ getCurrentLead?.lead_from_funnel?.budget }}</span>
            </v-col>
            <v-col class="d-flex flex-column" cols="2">
              <span><b>Tercih ettiği eğitim süresi </b></span>
              <span>{{
                getCurrentLead?.lead_from_funnel?.preferred_education_duration
              }}</span>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-system-bar
        v-if="getCurrentLead.user"
        class="pa-4 my-2 text-white"
        color="indigo"
        dark
      >
        <v-row class="text-body-1" justify="space-between">
          <v-col class="text-center">
            <span class="text-lg-h6 text-md-body-1 text-center">
              <b>Kullanıcı Bilgileri </b>
            </span>
          </v-col>
        </v-row>
      </v-system-bar>
      <v-row
        v-if="getCurrentLead.user"
        class="text-body-1 pa-4"
        justify="space-between"
      >
        <v-col class="d-flex flex-column" cols="3">
          <span v-if="getCurrentLead?.user" class="d-flex align-items-center">
            <b class="text-nowrap mr-1">Adı: </b>
            {{ getCurrentLead.user.name || "Belirtilmedi" }}

            <EditUserNameModal
              :currentLead="getCurrentLead"
              @saved="onUserNameUpdated"
            />
          </span>

          <span class="d-flex align-items-center">
            <b class="text-nowrap mr-1">E-Posta: </b>
            <span
              v-if="getCurrentLead?.user?.emails?.length > 0"
              class="d-flex align-items-center"
            >
              <span class="mr-2 text-no-wrap">
                {{ primaryEmail(getCurrentLead) || "E-posta bulunamadı!" }}
              </span>

              <v-btn
                color="grey"
                icon
                @click="openEmailModal('edit', getCurrentLead?.user)"
              >
                <v-icon dense>mdi-pencil</v-icon>
              </v-btn>
            </span>
            <span v-else class="d-flex align-items-center">
              <span class="text-danger text-nowrap mr-5">
                Kullanıcının e-posta adresi mevcut değil!
              </span>
              <v-btn color="success" icon @click="openEmailModal('add')">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </span>
          </span>
          <span class="d-flex align-items-center">
            <b lass="text-nowrap">Telefon: </b>
            <span class="ml-1 mr-2 text-no-wrap">
              {{ getCurrentLead?.user.phone || "Telefon numarası bulanamadı." }}
            </span>
            <EditUserPhoneModal :currentLead="getCurrentLead">
              <v-btn
                :color="getCurrentLead?.user.phone ? 'grey' : 'success'"
                icon
                small
                v-bind="$attrs"
                v-on="$listeners"
              >
                <v-icon>{{
                  getCurrentLead?.user.phone ? "mdi-pencil" : "mdi-plus"
                }}</v-icon>
              </v-btn>
            </EditUserPhoneModal>
          </span>
        </v-col>

        <!--Email Modal-->
        <v-dialog v-model="emailModelFlag" max-width="500">
          <v-card>
            <v-toolbar class="text-white" color="primary">
              <v-toolbar-title>
                {{ mode === "edit" ? "E-posta Güncelle" : "E-posta Ekle" }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn dark icon @click="emailModelFlag = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-5">
              <v-form ref="form">
                <v-text-field
                  v-model="modalData.email"
                  label="E-posta Adresi"
                  required
                ></v-text-field>
                <v-btn color="primary" @click="saveEmailData(getCurrentLead)">{{
                  mode === "edit" ? "Güncelle" : "Ekle"
                }}</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--Modal End-->
      </v-row>
      <v-tabs v-model="tab" background-color="indigo" dark grow>
        <v-tabs-slider color="success"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in items"
          :key="index"
          class="d-flex justify-content-start"
        >
          {{ item.text }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, index) in items" :key="index">
          <component
            :is="item.value"
            :leadName="getCurrentLead.name"
            :logs="item.value === 'LogTable' ? logs : null"
            :pagination="item.value === 'LogTable' ? pagination : null"
            :showDescription="item.value === 'LogTable' ? true : false"
            :user_id="item.value === 'Offers' ? getCurrentLead?.user_id : null"
            v-bind="item.attrs"
            @get-logs="getLogs($event)"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { GET_LEAD } from "@/core/services/store/leads.module";
import { mapActions, mapGetters } from "vuex";

import { formatPhoneInput } from "@/core/helper.js";

import Card from "@/view/content/components/Card";
import LogTable from "@/view/content/components/logs/LogTable.vue";
import SendRegisterForm from "@/view/content/components/SendRegisterForm.vue";
import SendVerifyEmailAgain from "@/view/content/components/SendVerifyEmailAgain.vue";
import Notes from "@/view/content/notes/Notes.vue";
import NoteTable from "@/view/content/notes/NoteTable.vue";
import Offers from "@/view/content/offers/Offers.vue";
import SMAgentActionButtons from "@/view/content/siliconmade/SM-Agent-Action-Buttons.vue";
import EditUserPhoneModal from "./EditUserPhoneModal.vue";
import EditUserNameModal from "./EditUserNameModal.vue";

export default {
  components: {
    Card,
    Notes,
    SMAgentActionButtons,
    LogTable,
    NoteTable,
    Offers,
    SendRegisterForm,
    SendVerifyEmailAgain,
    EditUserPhoneModal,
    EditUserNameModal,
  },
  data() {
    return {
      emailModelFlag: false,
      mode: "",
      modalData: {
        email: "",
      },
      lead: {},
      search: "",
      open: false,
      loading: !!this.$route.params.id,
      flowDialog: false,
      items: [
        {
          value: "NoteTable",
          text: "Görüşmeler ve Notlar",
          attrs: {
            noteable_type: "App\\Models\\Lead",
            noteable_id: Number(this.$route.params.id),
            fromShowLeadPage: true,
          },
        },
        {
          value: "LogTable",
          text: "Aktivite Logları",
          attrs: {
            pagination: this.pagination,
            logs: this.logs,
            loading: false,
            showDescription: true,
          },
        },
        {
          value: "Offers",
          text: "Teklifler",
        },
      ],
      tab: null,
      pagination: {
        last_page: 0,
        per_page: 0,
        current_page: 1,
        total: 0,
      },
      logs: [],
      agentLogs: [],
      agentDialog: false,
      leadDialog: false,
      leadFlow: [],
      filteredLeads: [],
    };
  },
  created() {
    this.$store
      .dispatch("getLead", this.$route.params.id)
      .then(() => {
        this.getLogs();
      })
      .finally(() => {
        this.loading = false;
      });
  },
  mounted() {
    if (this.$route.params.id) {
      this.getLead(Number(this.$route.params.id))
        .then(() => {
          this.getLogs();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    onUserNameUpdated(newName) {
      this.getCurrentLead.user.name = newName;
    },
    primaryEmail(getCurrentLead) {
      const primary = getCurrentLead?.user?.emails.find(
        (email) => email.is_primary === 1
      );
      return primary ? primary.email : null;
    },
    openEmailModal(mode, user = null) {
      this.mode = mode;
      if (mode === "edit" && user) {
        this.modalData.email = user.email?.email || "";
      } else {
        this.modalData.email = "";
      }
      this.emailModelFlag = true;
    },
    saveEmailData(getCurrentLead) {
      const updatedEmail = this.modalData.email;
      if (this.mode === "edit") {
        this.$apiService
          .patch("email/updateUserEmail", {
            email: this.modalData.email,
            userId: getCurrentLead.user.id,
          })
          .then(() => {
            const primaryEmailObj = getCurrentLead.user.emails.find(
              (email) => email.is_primary === 1
            );
            if (primaryEmailObj) {
              primaryEmailObj.email = updatedEmail;
            }
            this.$toast.success(
              "Email güncelleme işlemi başarı ile gerçekleştirildi.",
              {
                duration: 2000,
                position: "bottom-right",
              }
            );
          })
          .catch(() => {
            this.$toast.error("Email işlemi sırasında bir hata oluştu.", {
              duration: 2000,
              position: "bottom-right",
            });
          });
      } else {
        this.$apiService
          .post("email/createUserEmail", {
            email: this.modalData.email,
            userId: getCurrentLead.user.id,
          })
          .then(() => {
            getCurrentLead.user.emails.push({
              email: updatedEmail,
              is_primary: 0,
            });

            this.$toast.success("Email işlemı başarıyle gerçekleştirildi", {
              duration: 2000,
              position: "bottom-right",
            });
          })
          .catch(() => {
            this.$toast.error(
              "Email işlemı sırasında bir hata oluştu. Girdiğiniz email önceden mevcut olabilir",
              {
                duration: 2000,
                position: "bottom-right",
              }
            );
          });
      }
      this.emailModelFlag = false;
    },
    ...mapActions([GET_LEAD, "fetchResultCodes"]),
    formatPhoneInput,
    getLogs(currentPage = this.pagination.current_page) {
      this.$apiService
        .get(`/logs/lead`, {
          params: {
            log_name: "lead",
            page: currentPage,
            subject_id: this.$route.params.id,
          },
        })
        .then(({ data }) => {
          this.pagination = {
            last_page: data.last_page,
            per_page: data.per_page,
            current_page: data.current_page,
            total: data.total,
          };
          this.logs = data.data;
          this.agentLogs = this.getAgentLogs();
          this.leadFlow = this.getLeadFlow();
        })
        .catch(() => {
          this.$toast.error(
            "İşlem kayıtları getirilirken bir hata oluştu. Lütfen yenile butonuna tıklayarak tekrar deneyiniz.",
            {
              duration: 2000,
              position: "bottom-right",
            }
          );
        });
    },
    getLeadResultCodeTranslate(resultCodeId) {
      return this.resultCodes.find((code) => code.id === resultCodeId)?.name;
    },
    searchLead() {
      this.filteredLeads = this.leads
        .filter((lead) => lead.name.includes(this.search))
        .slice(0, 5);
    },
    returnLocaleDate(date) {
      return this.$moment(date).format("DD MMMM YYYY HH:mm:ss");
    },
    getAgentLogs() {
      return this.logs.filter((log) => log.event === "Agent Atandı");
    },
    getLeadFlow() {
      return this.logs.filter((log) => log.event === "Lead Durumu Değişti");
    },
    getLeadStatusTranslate(status) {
      const leadStatuses = JSON.parse(localStorage.getItem("lead_statuses"));
      const translate = leadStatuses.find((s) => s.value === status).translate;
      switch (translate) {
        case "Teklif Taslağı Oluşturuldu":
          return "T.T.O.";
        case "Kullanıcı Kaydı Tamamlandı":
          return "K.K.T.";
        case "E-Posta Doğrulanması Bekleniyor":
          return "E.P.D.B.";
        default:
          return translate;
      }
    },
    getLeadApplicationReason(id) {
      const leadReasons = [
        { id: 1, text: "Yeni Meslek" },
        { id: 2, text: "Meslek Değiştirmek" },
        { id: 3, text: "Girişimci" },
        { id: 4, text: "Diğer" },
      ];
      return leadReasons.find((reason) => reason.id === id).text;
    },
  },
  computed: {
    ...mapGetters(["getCurrentLead", "resultCodes", "getCurrentUserRoles"]),
    isAgent() {
      return (
        this.getCurrentUserRoles.length === 1 &&
        this.getCurrentUserRoles.includes("agent")
      );
    },
    title() {
      return "Lead " + " - " + this.getCurrentLead.name;
    },
    Agents() {
      const agents = JSON.parse(localStorage.getItem("agents"));
      return agents;
    },
  },
  watch: {
    getCurrentLead: {
      immediate: true,
      handler(lead) {
        if (lead?.name) document.title = `Lead - ${lead.name}`;
      },
    },
    agentDialog(val) {
      if (val) {
        this.getLogs();
      }
    },
    leadDialog(val) {
      if (val) {
        this.getLogs();
      }
    },
    tab(tab) {
      if (tab === 1) {
        this.getLogs();
      }
    },
  },
};
</script>

<style>
.user-management--disabled {
  pointer-events: none;
  opacity: 0.6;
  filter: grayscale(100%);
}
</style>
